// @core/api/endpoints/localization/review_translation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReviewTranslationRequest,
  TranslationResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Review translation
 * Marks a translation as reviewed. The reviewer is recorded.
 */
export async function ReviewTranslation(
  translation_id: string,
  data: ReviewTranslationRequest,
  options?: RequestOptions
): Promise<TranslationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/translations/:translation_id/review`;
  requestPath = requestPath.replace(':translation_id', encodeURIComponent(translation_id));
  const requestOptions = options;
  return client.post<TranslationResponse>(requestPath, data, requestOptions);
}
